import {useContext} from 'react';
import {FabricContext} from '~/common/fabric/context/FabricContext';
import {useMatchQuery} from '~/common/hooks/useMatchQuery';
import {Button} from '~library/atoms/Button';
import {largishAndUp} from '~libSass/base/_exports.sass';

export const ResetImageXY = ({label, dataQaId, uyoImage, disabled = false}) => {
  const {canvas} = useContext(FabricContext);
  const {matches: isDesktop} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const isMobile = !isDesktop;

  const resetUYOImage = () => {
    const rect = canvas.getObjects().find((obj) => obj.type === 'rect');
    const effectiveWidth = rect.width * rect.scaleX;
    const effectiveHeight = rect.height * rect.scaleY;
    const scaleX = effectiveWidth / uyoImage.width;
    const scaleY = effectiveHeight / uyoImage.height;
    const scale = Math.min(scaleX, scaleY);
    const centerX = rect.left + (rect.width * rect.scaleX) / 2;
    const centerY = rect.top + (rect.height * rect.scaleY) / 2;

    uyoImage.scale(scale).set({
      left: centerX,
      top: centerY,
      originX: 'center',
      originY: 'center',
      centeredRotation: true,
      hasControls: false,
      // biome-ignore lint/style/useNamingConvention: existing error
      _originalObject: rect.toJSON(),
    });

    uyoImage.rotate(0);

    canvas.setActiveObject(uyoImage);
    canvas.renderAll();
    canvas.fire('object:modified');
  };

  return (
    <Button
      onClick={resetUYOImage}
      data-qa-id={dataQaId}
      variant="link"
      size="small"
      className="reset_all__button"
      disabled={disabled}
    >
      {isMobile ? 'Reset' : label}
    </Button>
  );
};
